import * as types from './types'

export const updateMerchant = (merchant) => ({
  type: types.UPDATE_MERCHANT,
  merchant,
})

export const loadingMerchant = (isLoading) => ({
  type: types.LOADING_MERCHANT,
  isLoading,
})

const receiveInitalStateSuccess = (merchant) => ({
  type: types.RECEIVE_INITIAL_STATE_SUCCESS,
  merchant,
})

export default receiveInitalStateSuccess
